// Daemon name → human label, used by the /agents page.
//
// Naming convention (see packages/shared/src/heartbeat/read.ts):
//   <process>_<logical_name>
// e.g. 'bridge_imessage', 'workers_email_triage_classify'.
//
// We strip the process prefix, title-case the remainder, and tighten the
// known compound prefixes "Email Triage" / "Drafts Writeback" with an
// en-dash separator so they read as the workflow names humans use in
// standups, not as run-on identifiers.
//
// Unknown prefixes fall through unchanged (best-effort) rather than
// throwing — a new daemon shipped without a row in the alias map should
// still render legibly.

const COMPOUND_REWRITES: Array<[RegExp, string]> = [
  [/^Email Triage (Classify|Draft)$/, 'Email Triage – $1'],
  [/^Email Drafts Writeback$/, 'Email Drafts – Writeback'],
];

const PREFIX_LABELS: Record<string, string | null> = {
  workers: null,
  bridge: 'Bridge',
};

export function humanizeDaemonName(name: string): string {
  const firstUnderscore = name.indexOf('_');
  if (firstUnderscore < 0) return titleCase(name);
  const prefix = name.slice(0, firstUnderscore);
  const rest = name.slice(firstUnderscore + 1);

  const titled = titleCase(rest.replace(/_/g, ' '));

  const suffix = PREFIX_LABELS[prefix];
  let label =
    suffix === undefined
      ? titleCase(prefix.replace(/_/g, ' ')) + ' ' + titled
      : suffix === null
        ? titled
        : `${titled} ${suffix}`;

  for (const [pattern, replacement] of COMPOUND_REWRITES) {
    if (pattern.test(label)) {
      label = label.replace(pattern, replacement);
      break;
    }
  }
  return label;
}

function titleCase(s: string): string {
  return s
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => {
      if (w.toLowerCase() === 'imessage') return 'iMessage';
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    })
    .join(' ');
}
